import CountyLinkStore from '../store/county-link-store';
import {CountyLinkResource} from '../../entity/resource/county-link-resource';

export default class CountyLinkService {
  countyLinkStore: CountyLinkStore;

  constructor(countyLinkStore: CountyLinkStore) {
    this.countyLinkStore = countyLinkStore;
  }

  getCountyLinks = async (countyId: string): Promise<CountyLinkResource | undefined> => {
    return this.countyLinkStore.getCountyLinks(countyId);
  }
}
